export default __webpack_public_path__ + "static/media/viewFigs.dda2c4b3.svg";